import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useParams } from "react-router-dom";

import "swiper/css";
import "../../../assets/css/ClientsSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const clientsData = [
  { name: "Client 1", logo: `${BACKEND_URL}upload/other_agencies/others_01.jpg` },
  { name: "Client 2", logo: `${BACKEND_URL}upload/other_agencies/others_02.jpg` },
  { name: "Client 3", logo: `${BACKEND_URL}upload/other_agencies/others_03.jpg` },
  { name: "Client 4", logo: `${BACKEND_URL}upload/other_agencies/others_04.jpg` },
  { name: "Client 5", logo: `${BACKEND_URL}upload/other_agencies/others_05.jpg` },
  { name: "Client 6", logo: `${BACKEND_URL}upload/other_agencies/others_06.jpg` },
  { name: "Client 7", logo: `${BACKEND_URL}upload/other_agencies/others_07.jpg` },
  { name: "Client 8", logo: `${BACKEND_URL}upload/other_agencies/others_08.jpg` },
  { name: "Client 9", logo: `${BACKEND_URL}upload/other_agencies/others_09.jpg` },
  { name: "Client 10", logo: `${BACKEND_URL}upload/other_agencies/others_10.jpg` },
];

function ClientsSection() {
  const { section, id } = useParams();

  return (
    <section id="clients" className="fmw-partners-section" aria-label="Partner agencies">
      <div className="container">
        <header className="fmw-partners-heading">
          <span className="fmw-partners-kicker">WORKING TOGETHER</span>
          <h2>Our Agencies</h2>
          {/* <p>Partner institutions and agencies contributing to housing and urban development in Nigeria.</p> */}
        </header>

        <div className="fmw-partners-carousel">
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2600, disableOnInteraction: false, pauseOnMouseEnter: true }}
            loop={clientsData.length > 6}
            speed={650}
            spaceBetween={18}
            slidesPerView={2}
            breakpoints={{
              576: { slidesPerView: 3, spaceBetween: 18 },
              768: { slidesPerView: 4, spaceBetween: 20 },
              992: { slidesPerView: 5, spaceBetween: 22 },
              1200: { slidesPerView: 6, spaceBetween: 24 },
            }}
          >
            {clientsData.map((client, index) => (
              <SwiperSlide key={client.logo || index} className="fmw-partner-slide">
                <div className="fmw-partner-card">
                  <div className="fmw-partner-logo-frame">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={client.logo}
                      alt={client.name}
                      className="fmw-partner-logo"
                    />
                  </div>
                  {/* <span className="fmw-partner-label">{client.name}</span> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="fmw-partners-footer">
          <span className="fmw-partners-rule" />
          <span>Agencies Driving Infrastructure Growth</span>
          <span className="fmw-partners-rule" />
        </div>
      </div>
    </section>
  );
}

export default React.memo(ClientsSection);
